import styled from "styled-components"
import tw from "tailwind.macro"

export default styled.p`
  font-size: 16px;
  line-height: 22px;
  ${tw`text-grey`};
`
